export enum QualitativeLevel {
    Low,
    Close,
    Good,
    Great,
    High
}